import { ComponentProps } from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { Circle } from 'lucide-react';

import { cn } from '@/lib/utils';

const RadioGroup = (props: ComponentProps<typeof RadioGroupPrimitive.Root>) => {
  const { className, ...restProps } = props;

  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn('grid gap-3', className)}
      {...restProps}
    />
  );
};

const RadioGroupItem = (
  props: ComponentProps<typeof RadioGroupPrimitive.Item>,
) => {
  const { className, ...restProps } = props;

  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        'bg-card text-primary-soft-foreground data-[state=checked]:border-primary focus-visible:border-ring aspect-square size-4 shrink-0 cursor-pointer rounded-full border border-input shadow-xs outline-none focus-visible:ring-3 focus-visible:ring-ring/25 disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...restProps}
    >
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="flex items-center justify-center"
      >
        <Circle className="size-2.5 fill-current text-current" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
};

export { RadioGroup, RadioGroupItem };
